import React from "react";

const MaskShade: React.FC<any> = ({ children, onClick, visible }) => {
  return (
    <>
      {visible && <div id={"Mask"} className='fixed  z-[101] h-screen w-screen top-0 left-0' onClick={onClick} />}
      {children}
    </>
  );
};

export default MaskShade;
